"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _addByDatasetButton = _interopRequireDefault(require("../add-by-dataset-button"));

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project
function AddFilterButtonFactory() {
  var AddFilterButton = function AddFilterButton(_ref) {
    var datasets = _ref.datasets,
        onAdd = _ref.onAdd;
    return /*#__PURE__*/_react["default"].createElement(_addByDatasetButton["default"], {
      datasets: datasets,
      className: "add-filter-button",
      width: "105px",
      onAdd: onAdd,
      buttonIntlId: "filterManager.addFilter"
    });
  };

  return AddFilterButton;
}

var _default = AddFilterButtonFactory;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zaWRlLXBhbmVsL2ZpbHRlci1wYW5lbC9hZGQtZmlsdGVyLWJ1dHRvbi50c3giXSwibmFtZXMiOlsiQWRkRmlsdGVyQnV0dG9uRmFjdG9yeSIsIkFkZEZpbHRlckJ1dHRvbiIsImRhdGFzZXRzIiwib25BZGQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUdBOztBQUVBOztBQUxBO0FBQ0E7QUFXQSxTQUFTQSxzQkFBVCxHQUFrQztBQUNoQyxNQUFNQyxlQUErQyxHQUFHLFNBQWxEQSxlQUFrRCxPQUF1QjtBQUFBLFFBQXJCQyxRQUFxQixRQUFyQkEsUUFBcUI7QUFBQSxRQUFYQyxLQUFXLFFBQVhBLEtBQVc7QUFDN0Usd0JBQ0UsZ0NBQUMsOEJBQUQ7QUFDRSxNQUFBLFFBQVEsRUFBRUQsUUFEWjtBQUVFLE1BQUEsU0FBUyxFQUFDLG1CQUZaO0FBR0UsTUFBQSxLQUFLLEVBQUMsT0FIUjtBQUlFLE1BQUEsS0FBSyxFQUFFQyxLQUpUO0FBS0UsTUFBQSxZQUFZLEVBQUM7QUFMZixNQURGO0FBU0QsR0FWRDs7QUFZQSxTQUFPRixlQUFQO0FBQ0Q7O2VBRWNELHNCIiwic291cmNlc0NvbnRlbnQiOlsiLy8gU1BEWC1MaWNlbnNlLUlkZW50aWZpZXI6IE1JVFxuLy8gQ29weXJpZ2h0IGNvbnRyaWJ1dG9ycyB0byB0aGUga2VwbGVyLmdsIHByb2plY3RcblxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7RGF0YXNldHN9IGZyb20gJ0BrZXBsZXIuZ2wvdGFibGUnO1xuaW1wb3J0IEFkZEJ5RGF0YXNldEJ1dHRvbiBmcm9tICcuLi9hZGQtYnktZGF0YXNldC1idXR0b24nO1xuXG5leHBvcnQgdHlwZSBBZGRGaWx0ZXJCdXR0b25Qcm9wcyA9IHtcbiAgZGF0YXNldHM6IERhdGFzZXRzO1xuICBvbkFkZDogKGRhdGFJZDogc3RyaW5nKSA9PiB2b2lkO1xufTtcblxuZnVuY3Rpb24gQWRkRmlsdGVyQnV0dG9uRmFjdG9yeSgpIHtcbiAgY29uc3QgQWRkRmlsdGVyQnV0dG9uOiBSZWFjdC5GQzxBZGRGaWx0ZXJCdXR0b25Qcm9wcz4gPSAoe2RhdGFzZXRzLCBvbkFkZH0pID0+IHtcbiAgICByZXR1cm4gKFxuICAgICAgPEFkZEJ5RGF0YXNldEJ1dHRvblxuICAgICAgICBkYXRhc2V0cz17ZGF0YXNldHN9XG4gICAgICAgIGNsYXNzTmFtZT1cImFkZC1maWx0ZXItYnV0dG9uXCJcbiAgICAgICAgd2lkdGg9XCIxMDVweFwiXG4gICAgICAgIG9uQWRkPXtvbkFkZH1cbiAgICAgICAgYnV0dG9uSW50bElkPVwiZmlsdGVyTWFuYWdlci5hZGRGaWx0ZXJcIlxuICAgICAgLz5cbiAgICApO1xuICB9O1xuXG4gIHJldHVybiBBZGRGaWx0ZXJCdXR0b247XG59XG5cbmV4cG9ydCBkZWZhdWx0IEFkZEZpbHRlckJ1dHRvbkZhY3Rvcnk7XG4iXX0=